import { Aplicativo } from './aplicativo';

export class Rol {

    idRol: string;

    nombre: string;

    descripcion: string;

    aplicativo: Aplicativo;

    requiereUnidad : boolean;

}
